import { render, staticRenderFns } from "./DemoArticle.vue?vue&type=template&id=6a89015e&"
import script from "./DemoArticle.vue?vue&type=script&lang=js&"
export * from "./DemoArticle.vue?vue&type=script&lang=js&"
import style0 from "./DemoArticle.vue?vue&type=style&index=0&id=6a89015e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports